<template>
  <div class="grid grid-rows-[auto_1fr] overflow-hidden"><slot></slot></div>
</template>
